!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define(["react", "react-dom"], t) : "object" == typeof exports ? exports["react-scroll-to"] = t(require("react"), require("react-dom")) : e["react-scroll-to"] = t(e.React, e.ReactDOM);
}("undefined" != typeof self ? self : this, function (e, t) {
  return function (e) {
    var t = {};

    function r(o) {
      if (t[o]) return t[o].exports;
      var n = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, o) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) {
        r.d(o, n, function (t) {
          return e[t];
        }.bind(null, n));
      }
      return o;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "/Users/dpaulus/Desktop/Projects/react-scroll-to", r(r.s = 3);
  }([function (e, t, r) {
    "use strict";

    function o(e) {
      return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function n(e, t) {
      for (var r = 0; r < t.length; r++) {
        var o = t[r];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    function l(e, t) {
      return !t || "object" !== o(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function c(e) {
      return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function i(e, t) {
      return (i = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var u = this && this.__rest || function (e, t) {
      var r = {};

      for (var o in e) {
        Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;

        for (o = Object.getOwnPropertySymbols(e); n < o.length; n++) {
          t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (r[o[n]] = e[o[n]]);
        }
      }

      return r;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = r(1),
        f = r(4);
    t.ScrollToContext = a.createContext({
      addScrollArea: function addScrollArea(e, t) {},
      removeScrollArea: function removeScrollArea(e) {}
    });

    var s = function (e) {
      function r(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, r), (t = l(this, c(r).call(this, e))).scrollArea = {}, t.addScrollArea = function (e, r) {
          t.scrollArea[e] = r;
        }, t.removeScrollArea = function (e) {
          delete t.scrollArea[e];
        }, t.handleScroll = function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = Object.keys(t.scrollArea),
              o = e.id,
              n = e.ref,
              l = u(e, ["id", "ref"]);

          if (n) {
            var c = n.current ? n.current : n;

            t._scrollNode(c, l);
          } else if (o) {
            var i = t.scrollArea[o];

            t._scrollNode(i, l);
          } else r.length > 0 ? r.forEach(function (e) {
            var r = t.scrollArea[e];

            t._scrollNode(r, l);
          }) : window && t._scrollNode(window, l);
        }, t._scrollNode = function (e, t) {
          if (e) {
            var r = t.y,
                o = t.x;

            if (a.isValidElement(e)) {
              var n = f.default.findDOMNode(e);
              n && (e = n);
            }

            e.scrollTo ? e.scrollTo({
              top: r,
              left: o,
              behavior: t.smooth ? "smooth" : "auto"
            }) : (e.scrollLeft = o, e.scrollTop = r);
          }
        }, t.scrollArea = {}, t.getContext = {
          addScrollArea: t.addScrollArea,
          removeScrollArea: t.removeScrollArea
        }, t;
      }

      var o, s, p;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && i(e, t);
      }(r, e), o = r, (s = [{
        key: "render",
        value: function value() {
          return a.createElement(t.ScrollToContext.Provider, {
            value: this.getContext
          }, this.props.children && this.props.children({
            scroll: this.handleScroll
          }));
        }
      }]) && n(o.prototype, s), p && n(o, p), r;
    }(a.Component);

    t.default = s;
  }, function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(6);
    t.getDisplayName = o.getDisplayName;
    var n = r(7);
    t.generateId = n.generateId;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(0);
    t.ScrollTo = o.default;
    var n = r(5);
    t.ScrollArea = n.default;
    var l = r(8);
    t.ScrollToHOC = l.default;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t, r) {
    "use strict";

    function o(e) {
      return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function l(e, t) {
      for (var r = 0; r < t.length; r++) {
        var o = t[r];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    function c(e, t) {
      return !t || "object" !== o(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function i(e) {
      return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function u(e, t) {
      return (u = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var a = this && this.__rest || function (e, t) {
      var r = {};

      for (var o in e) {
        Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;

        for (o = Object.getOwnPropertySymbols(e); n < o.length; n++) {
          t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (r[o[n]] = e[o[n]]);
        }
      }

      return r;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var f = r(1),
        s = r(0),
        p = r(2),
        d = function (e) {
      function t() {
        var e;
        return n(this, t), (e = c(this, i(t).apply(this, arguments))).node = f.createRef(), e.id = e.props.id || p.generateId(), e;
      }

      var r, o, s;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && u(e, t);
      }(t, e), r = t, (o = [{
        key: "componentDidMount",
        value: function value() {
          this.props.addScrollArea(this.id, this.node.current);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.removeScrollArea(this.id);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.children,
              r = (e.removeScrollArea, e.addScrollArea, a(e, ["children", "removeScrollArea", "addScrollArea"]));
          return f.createElement("div", Object.assign({}, r, {
            ref: this.node
          }), t);
        }
      }]) && l(r.prototype, o), s && l(r, s), t;
    }(f.Component);

    t.ScrollArea = d, t.default = function (e) {
      return f.createElement(s.ScrollToContext.Consumer, null, function (t) {
        var r = t.addScrollArea,
            o = t.removeScrollArea;
        return f.createElement(d, Object.assign({}, e, {
          removeScrollArea: o,
          addScrollArea: r
        }));
      });
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getDisplayName = function (e) {
      var t = e.displayName,
          r = e.name;
      return t || r ? t || r : "string" == typeof e && e.length > 0 ? e : "Unknown";
    };
  }, function (e, t, r) {
    "use strict";

    var o;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.generateId = (o = 0, function () {
      return "scrollto-".concat(o++);
    });
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(1),
        n = r(2),
        l = r(0);

    t.default = function (e) {
      var t = function t(_t) {
        return o.createElement(l.default, null, function (r) {
          return o.createElement(e, Object.assign({}, _t, r));
        });
      };

      return t.displayName = "WithScrollToHOC(".concat(n.getDisplayName(e), ")"), t;
    };
  }]);
});